import type { RouteProps } from "../../types";

export const useLoggedInUser = ({ user }: Pick<RouteProps, "user">) => {
  if (!user) throw new Error("User must be logged in");
  return user;
};
